import React from "react";
import { NavLink } from "react-router";
import { useSelector } from "react-redux";

const NavItem = ({ to, icon, activeIcon, label, end = false }) => (
  <NavLink to={to} end={end} className="nav-link" role="button">
    {({ isActive }) => (
      <>
        <i className={`bi ${isActive ? activeIcon : icon}`} /> {label}
      </>
    )}
  </NavLink>
);

const Sidebar = () => {
  const companyInfo = useSelector((state) => state.homeReducer.companyInfo);
  const local = useSelector((state) => state.homeReducer.local);
  const companyId = `/${companyInfo.id}`;

  return (
    <div className="mowaamah-sidebar">
      <NavItem
        to={companyId}
        end
        icon="bi-house-door"
        activeIcon="bi-house-door-fill"
        label={local.home}
      />
      <NavItem
        to={`${companyId}/entity`}
        icon="bi-file-text"
        activeIcon="bi-file-text-fill"
        label={local.entityDetails}
      />
      <NavItem
        to={`${companyId}/certificate`}
        icon="bi-file-earmark-medical"
        activeIcon="bi-file-earmark-medical-fill"
        label={local.mowaamahCertificate}
      />
      <NavItem
        to={`${companyId}/training`}
        icon="bi-person-vcard"
        activeIcon="bi-person-vcard-fill"
        label={local.training}
      />
      <NavItem
        to={`${companyId}/workshop`}
        icon="bi-person-gear"
        activeIcon="bi-person-fill-gear"
        label={local.workshop}
      />
      <NavItem
        to={`${companyId}/jobs`}
        icon="bi-briefcase"
        activeIcon="bi-briefcase-fill"
        label={local.jobs}
      />
      <NavItem
        to={`${companyId}/consultation`}
        icon="bi-person-check"
        activeIcon="bi-person-fill-check"
        label={local.consultationMowaamah}
      />
      <NavItem
        to={`${companyId}/support`}
        icon="bi-chat-left-text"
        activeIcon="bi-chat-left-text-fill"
        label={local.contactUs}
      />
    </div>
  );
};

export default Sidebar;
